module.exports = "https://health.dajiuxing.com.cn/img/assets/img/turntable_new.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fturntable_new.png
// module id = oz7/
// module chunks = 93